/** Saved dashboard views (PROMPT §10) — stored locally, keyed by query string. */
export interface SavedView {
  name: string;
  query: string; // URL search string, e.g. "from=...&to=...&sedes=1,2"
}

const KEY = 'lidotel.savedViews';

export function listViews(): SavedView[] {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as SavedView[]) : [];
  } catch {
    return [];
  }
}

function persist(views: SavedView[]): SavedView[] {
  try {
    localStorage.setItem(KEY, JSON.stringify(views));
  } catch {
    /* ignore quota / private mode */
  }
  return views;
}

export function saveView(name: string, query: string): SavedView[] {
  const trimmed = name.trim();
  if (!trimmed) return listViews();
  const views = listViews().filter((v) => v.name !== trimmed);
  views.push({ name: trimmed, query });
  return persist(views);
}

export function deleteView(name: string): SavedView[] {
  return persist(listViews().filter((v) => v.name !== name));
}
